import { render } from "./Infos.vue?vue&type=template&id=4fcb3d04&scoped=true"
import script from "./Infos.vue?vue&type=script&lang=js"
export * from "./Infos.vue?vue&type=script&lang=js"

import "./Infos.vue?vue&type=style&index=0&id=4fcb3d04&lang=scss&scoped=true"

import exportComponent from "/builds/intratone/interface/intratoneinfov4/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fcb3d04"]])

export default __exports__